/* SourceComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;

const Renderer = require("./SourceRenderer");
const _ = require("lodash");
const SOURCE_LABELS = {
    LATEST: "Latest",
    DEFAULT: "Default"
};
class SourceColumnComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._Source = SOURCE_LABELS[value] || value;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._Source = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setSource(newVal);
        }
    }

    getValue() {
        return this.getSource();
    }

    setSource(newVal) {
        this._Source = SOURCE_LABELS[newVal] || newVal;
        this.emit("Source", newVal);
        return this;
    }

    getSource() {
        return this._Source;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SourceColumnComponent;
